import React from 'react';

import ModalRight from './ModalRight';
import FileViewerModal from './FileViewerModal';

import IconContainer from './IconContainer';
import { ReactComponent as FileIcon } from '../icons/file-content.svg';

const ViewFileById = ({ fileId }) => {
    const [isOpen, setIsOpen] = React.useState(false);

    return (
        <>
            <ModalRight isOpen={isOpen} closeModal={() => setIsOpen(false)} >
                <FileViewerModal closeModal={() => setIsOpen(false)} id={fileId} />
            </ModalRight>
            
            <IconContainer Icon={FileIcon} onClick={() => {setIsOpen(true)}} size = '17' color = 'blue' className = '' />
        </>
    )
}

export default ViewFileById;